export default "__VITE_ASSET__cfbf4b4c__"